var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappFooterCropped({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "166.32 159.84 749.52 760.3199999999999",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    width: 749.52,
    height: 760.3199999999999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "2015de0f-5a31-4969-86e8-d4ab0a9c893e",
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1080,
    width: 1080,
    ry: 0,
    rx: 0,
    y: -540,
    x: -540,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0736640d-49cd-412b-9700-91b370eb84c0",
    transform: "matrix(1 0 0 1 540 540)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50 0 0 50 -0.79 -0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 11.42 9.49 C 11.23 9.4 10.32 8.95 10.15 8.88 C 9.98 8.810000000000002 9.860000000000001 8.790000000000001 9.73 8.98 C 9.6 9.17 9.25 9.58 9.14 9.71 C 9.030000000000001 9.840000000000002 8.93 9.850000000000001 8.74 9.71 C 8.194276360153546 9.490995715660075 7.69026828958207 9.179796101615942 7.25 8.790000000000001 C 6.8514535304636315 8.414762477303077 6.514043428602139 7.979503445901753 6.249999999999999 7.500000000000001 C 6.14 7.320000000000001 6.25 7.220000000000001 6.33 7.120000000000001 C 6.41 7.020000000000001 6.51 6.910000000000001 6.61 6.800000000000001 C 6.6831287374183965 6.704868975711925 6.743631737455273 6.600669364537304 6.79 6.490000000000001 C 6.840255545952994 6.385740045225077 6.840255545952994 6.264259954774925 6.79 6.160000000000001 C 6.79 6.070000000000001 6.37 5.160000000000001 6.21 4.790000000000001 C 6.05 4.420000000000001 5.91 4.470000000000001 5.8 4.470000000000001 L 5.3999999999999995 4.470000000000001 C 5.209451623590532 4.477428713093112 5.029632515687426 4.56014550272854 4.8999999999999995 4.700000000000001 C 4.477003393424911 5.103650271776424 4.241441421809137 5.665374973321729 4.249999999999999 6.250000000000002 C 4.301149745900904 6.959980153273591 4.562206925176102 7.638728819389101 5.000000000000001 8.200000000000001 C 5.803370892290569 9.39343348573229 6.902471038093612 10.358160886437156 8.189999999999998 11 C 8.629999999999999 11.19 8.969999999999999 11.3 9.24 11.39 C 9.619143826830125 11.504596229810977 10.019897334226723 11.528572935381714 10.41 11.46 C 10.933716789940242 11.353752983337271 11.389940779961613 11.035120355385837 11.67 10.58 C 11.785306880755858 10.301941362101342 11.823313773557546 9.997886219687832 11.78 9.7 C 11.729999999999999 9.629999999999999 11.61 9.58 11.42 9.489999999999998 z",
    transform: "translate(-8.02, -7.98)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50 0 0 50 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M 13.29 2.68 C 11.89284311275116 1.2696244513146417 9.985178484645495 0.4834791036264825 7.999999999999994 0.49999999999999867 C 5.350973846583743 0.5138625592752051 2.909125846045705 1.9352162469676548 1.588838218289311 4.231816410693675 C 0.2685505905329171 6.528416574419695 0.26899308355429064 9.35381349652612 1.589999999999998 11.649999999999999 L 0.5899999999999999 15.5 L 4.529999999999999 14.5 C 5.619233164233047 15.09270625405809 6.83994966988634 15.402183678026532 8.079999999999997 15.400000000000002 L 8 15.4 C 11.022936386443876 15.419698258442528 13.757265639370344 13.608334547626512 14.918088143181956 10.817094046967966 C 16.07891064699357 8.02585354630942 15.43541941876565 4.809720154258601 13.29 2.679999999999998 z M 8 14.12 C 6.89055204709273 14.120880611050744 5.801732262860996 13.820158956358169 4.849999999999998 13.25 L 4.63 13.12 L 2.29 13.729999999999999 L 2.91 11.45 L 2.77 11.219999999999999 C 1.1169078659638405 8.557799277687845 1.7180321823996807 5.079713365896208 4.16876603444927 3.1267848275441885 C 6.6194998864988595 1.1738562891921696 10.144007230869084 1.3643294712789693 12.369999999999994 3.569999999999993 C 13.534612316628664 4.725226047253672 14.18670967715523 6.299626856922785 14.18 7.939999999999995 C 14.174494199780815 11.350836573742779 11.410836573742781 14.114494199780815 8 14.120000000000001 z",
    transform: "translate(-8.04, -8)",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFooterCropped);
export default __webpack_public_path__ + "static/media/whatsapp-footer-cropped.f670291ba0245af5ad2e8e94da93ef3e.svg";
export { ForwardRef as ReactComponent };